import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  product: null,
  products: [],
  success: false,
  error: null,
  message: null,
};

export const productReducer = createReducer(initialState, (builder) => {
  builder
    // Product Creation
    .addCase('createProductRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('createProductSuccess', (state, action) => {
      state.isLoading = false;
      state.product = action.payload;
      state.success = true;
    })
    .addCase('createProductFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })
    // Fetch All Products
    .addCase('getAllProductsRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('getAllProductsSuccess', (state, action) => {
      state.isLoading = false;
      state.products = action.payload;
    })
    .addCase('getAllProductsFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    // Fetch Products by Store
    .addCase('getProductsByStoreRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('getProductsByStoreSuccess', (state, action) => {
      state.isLoading = false;
      state.products = action.payload;
    })
    .addCase('getProductsByStoreFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    // Edit Product
    .addCase('editProductRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('editProductSuccess', (state, action) => {
      state.isLoading = false;
      state.product = action.payload;
      state.success = true;
    })
    .addCase('editProductFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })
    // Delete Product
    .addCase('deleteProductRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('deleteProductSuccess', (state, action) => {
      state.isLoading = false;
      state.message = action.payload;
    })
    .addCase('deleteProductFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    // Get Product by ID
    .addCase('getProductByIdRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('getProductByIdSuccess', (state, action) => {
      state.isLoading = false;
      state.product = action.payload;
    })
    .addCase('getProductByIdFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    // Clear Errors
    .addCase('clearErrors', (state) => {
      state.error = null;
    })
    // Clear Success Messages
    .addCase('clearSuccess', (state) => {
      state.message = null;
      state.success = false;
    });
});
